import React, { memo, ReactNode, useState } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { width } from 'Utils/screen';
import { Tab } from 'Components/Tabs/Tab';
import classes from './rocketScopeTabs.module.css';

interface Props {
  id?: string;
  className?: string;
  children?: ReactNode;
}

const VIEW_TAB = 'view-tab';
const UPLOAD_TAB = 'upload-tab';

const createTabs = (activeTab: string, onTabClick: (e: any) => void) => (
  <>
    <Tab
      key={VIEW_TAB}
      id={VIEW_TAB}
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === VIEW_TAB ? `active ${classes['active-Tab']}` : ''
      }`}
      target="rocketscopeview"
      onClick={onTabClick}
    >
      <span>View Scopes</span>
    </Tab>
    <Tab
      key={UPLOAD_TAB}
      id={UPLOAD_TAB}
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === UPLOAD_TAB ? `active ${classes['active-Tab']}` : ''
      }`}
      target="rocketscopeupload"
      onClick={onTabClick}
    >
      <span>Upload Scope Sheet</span>
    </Tab>
  </>
);

/*
  In order to override bootstraps active class on tabs, there is a click event onTabClick, which will get the name of the tab that was clicked
  and then trigger a re-render.  Note in the createTabs method above, where the active class is added or not, based on which tab was clicked.
*/
function RocketScopeTabs({ id = 'tabs', className, children }: Props) {
  // We want to set the initial active tab to the first tab in the incoming tabList
  const [activeTab, setActiveTab] = useState(VIEW_TAB);

  const onTabClick = (e: any) => {
    // Occasionally, e.currentTarget is undefined.  Set the current activeTab if we run into this bug
    setActiveTab(e?.currentTarget?.id || activeTab);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className={classes.tabContainerWrapper}>
            <div className={classes.tabsContainer}>
              <ul
                className={`nav nav-tabs ${width < 576 ? 'flex-sm-column' : 'width'}
                  ${classes.tabs} ${className || ''}`}
                id={id}
                role="tablist"
              >
                {createTabs(activeTab, onTabClick)}
              </ul>
            </div>
            <div
              className="tab-content w-100 h-100 d-inline-block"
              id="rocketscopeTabContent"
              style={{ height: 'auto' }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const RocketScopeTabsMemo = memo(RocketScopeTabs, areEqual);
export { RocketScopeTabsMemo as RocketScopeTabs };
